import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import createForm from "./Form";
import {CurrencyFormatter, UnitFormatter} from "../../../utils/formatters";
import ComponentConfig from "../../form/ComponentConfig";
import MoneyTransferList from "../lists/MoneyTransferList";
import Collapse from "../../layout/Collapse";
import Button from "../../form/Button";
import TextArea from "../../form/TextArea";
import DateTimeInput from "../../form/DateTimeInput";
import moment from "moment";
import MoneyRepositoryClosing from "./TillClosing/MoneyRepositoryClosing";
import VatRateClosing from "./TillClosing/VatRateClosing";
import {WrappedComponentEditorPropsType} from "../../form/ComponentEditor/ComponentEditor";
import StornoVatRateClosing from "./TillClosing/StornoVatRateClosing";
import {Tooltip} from "react-tippy";

class TillClosingForm extends React.Component<WrappedComponentEditorPropsType&{
    till: {
        id: string|number
    },
}, any> {

    state = {
        total: 0,
        count: 0,
    };

    render() {
        const tillProps = this.props.getFieldProps("till");
        const closings = (this.props.values.closings || []);
        const sumFilter = closings.map((closing) => ({field: "moneyrepository", value: closing.moneyrepository.repository_id}));

        return (
            <form className="till-closing" onSubmit={this.props.handleSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="row form-row">
                            <div className="col-md-2 col-md-push-10">
                                <div className="form-group">
                                    <TextInput
                                        name={this.props.componentConfig.idfield}
                                        value={this.props.values[this.props.componentConfig.idfield]}
                                        label="Kód"
                                        role="idfield"
                                        {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6 col-md-pull-2">
                                <div className="form-group">
                                    <Select
                                        objectValue={false}
                                        name="till"
                                        value={this.props.values.till}
                                        labelKey="displayname"
                                        component="Till"
                                        storeType="local"
                                        saveChanges={this.props.setFieldValue}
                                        label="Eladási pont"
                                        {...tillProps}
                                        disabled={this.props.till || tillProps.disabled}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4 col-md-pull-2">
                                <div className="form-group">
                                    <DateTimeInput
                                        name="closing_date"
                                        value={this.props.values.closing_date}
                                        saveChanges={this.props.setFieldValue}
                                        label="Zárás időpontja"
                                        isClearable={true}
                                        showTime={true}
                                        initialValue={moment().format("YYYY-MM-DD HH:mm:00")}
                                        minDate={this.props.values.before_closing_date}
                                        {...this.props.getFieldProps("closing_date")}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="section">
                        <div className="section-title">Pénztárak</div>
                        <div className="col-md-12">
                            <MoneyRepositoryClosing
                                {...this.props}
                                disabled={!!this.props.values[this.props.componentConfig.idfield]}
                            />
                        </div>
                    </div>
                </div>
                {/*<ShopSalesEditor
                    editor={ModalEditor}
                    list={(props) => <Fragment>
                        <label className="control-label">Félbe hagyott eladások</label>
                        {props.children}
                    </Fragment>}
                    closing={dateFilters.map((filter) => {
                        filter = {...filter};
                        filter.field = "created_at";
                        return filter;
                    })}
                />*/}
                <div className="row">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="section">
                                <div className="section-title">Pénztárgép záró jelentés</div>
                                <div className="col-md-12">
                                    <VatRateClosing
                                        {...this.props}
                                        disabled={!!this.props.values[this.props.componentConfig.idfield]}
                                    />
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group currency">
                                                <TextInput
                                                    name="total"
                                                    value={this.props.values.total}
                                                    disabled={this.props.isLoading}
                                                    formatter={CurrencyFormatter}
                                                    label="Forgalom"
                                                    saveChanges={this.props.setFieldValue}
                                                    {...this.props.getFieldProps("total")}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group currency">
                                                <Tooltip title={"Kerekítés: " + CurrencyFormatter(this.props.values.rounding_check).props.children}>
                                                    <TextInput
                                                        name="rounding_total"
                                                        value={this.props.values.rounding_total}
                                                        disabled={this.props.isLoading}
                                                        formatter={CurrencyFormatter}
                                                        label="Kerekítés"
                                                        saveChanges={this.props.setFieldValue}
                                                        {...this.props.getFieldProps("rounding_total")}
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group currency">
                                                <Tooltip title={"Utalványok: " + CurrencyFormatter(this.props.values.voucher_total_check).props.children}>
                                                    <TextInput
                                                        name="voucher_total"
                                                        value={this.props.values.voucher_total}
                                                        disabled={this.props.isLoading}
                                                        formatter={CurrencyFormatter}
                                                        label="Beváltott utalványok összege"
                                                        saveChanges={this.props.setFieldValue}
                                                        {...this.props.getFieldProps("voucher_total")}
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="section rtl">
                                <div className="section-title">Korrekciók</div>
                                <div className="col-md-12">
                                    <StornoVatRateClosing
                                        {...this.props}
                                        disabled={!!this.props.values[this.props.componentConfig.idfield]}
                                    />
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group currency">
                                        <Tooltip title="Minden kp-s és bankártyás sztornó összege">
                                            <TextInput
                                                name="total_storno"
                                                value={this.props.values.total_storno}
                                                disabled={this.props.isLoading}
                                                formatter={CurrencyFormatter}
                                                label="Összes sztornó"
                                                saveChanges={this.props.setFieldValue}
                                                {...this.props.getFieldProps("total_storno")}
                                            />
                                        </Tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <TextInput
                                name="closing_number"
                                value={this.props.values.closing_number}
                                label="Zárásszám"
                                required={true}
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("closing_number")}
                            />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <TextInput
                                name="transaction_count"
                                value={this.props.values.transaction_count}
                                formatter={UnitFormatter}
                                label="Tranzakciószám"
                                required={true}
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("transaction_count")}
                            />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <TextInput
                                disabled={true}
                                value={this.state.count}
                                formatter={UnitFormatter}
                                label="Tranzakciók száma"
                            />
                        </div>
                    </div>
                    {closings.length > 1 ? <Fragment>
                        <div className="col-md-12">
                            <div className="form-group">
                                <Collapse
                                    button={<Button
                                        block={true}
                                        color="default"
                                    >
                                        Összes tranzakció {CurrencyFormatter(this.state.total).props.children} <span className="caret"/>
                                    </Button>}
                                >
                                    <div>
                                        <ComponentConfig componentName="MoneyTransfer">
                                            {(props) =>
                                                <MoneyTransferList
                                                    {...props}
                                                    onLoadCompleted={(response) => {
                                                        this.setState({total: response.aggregations?.[0]?.total || 0, count: response.aggregations?.[0]?.total_count || 0});
                                                    }}
                                                    filter={[
                                                        ...(sumFilter.length ? [{
                                                            operator: "OR",
                                                            filters: sumFilter
                                                        }] : []),
                                                        {
                                                            field: "invoice_count",
                                                            value: 0
                                                        },
                                                        ...this.props.dateFilters
                                                    ]}
                                                />}
                                        </ComponentConfig>
                                    </div>
                                </Collapse>
                            </div>
                        </div>
                    </Fragment> : null}
                    <div className="col-md-12">
                        <div className="form-group">
                            <TextArea
                                disabled={this.props.isLoading}
                                name="comment"
                                value={this.props.values.comment}
                                label="Megjegyzés"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("comment")}
                            />
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(TillClosingForm);
